import { Toggle } from '@g17eco/molecules/toggle';
import { SurveyDelegationProps } from '../types';
import { ViewTemplate } from '../ViewTemplate';
import { ManageDelegatesBtn } from './ManageDelegatesBtn';
import { useToggle } from '@hooks/useToggle';
import { useGetSurveyUsersQuery } from '@api/survey-users';
import { QueryWrapper } from '@g17eco/molecules/query/QueryWrapper';
import { getUniqueUsers } from '@utils/delegation-users';
import { UsersTable } from './UsersTable';

type Props = Pick<SurveyDelegationProps, 'view' | 'onChangeView' | 'utrvIds' | 'survey' | 'isReadOnly'>;

export const UsersView = ({ view, onChangeView, utrvIds, survey, isReadOnly }: Props) => {
  const [platformDelegatesIncluded, toggle] = useToggle(true);
  return (
    <QueryWrapper
      query={useGetSurveyUsersQuery({
        surveyId: survey._id,
      })}
      onSuccess={(data) => {
        const users = getUniqueUsers({ users: data, platformDelegatesIncluded });

        return (
          <ViewTemplate
            view={view}
            onChangeView={onChangeView}
            actionBtns={
              <>
                <Toggle
                  className={{
                    form: 'd-flex align-items-center pl-0 mb-0 ms-4 justify-content-end',
                    label: 'text-md ms-2',
                  }}
                  checked={platformDelegatesIncluded}
                  onChange={toggle}
                  label='Platform delegated users'
                />
                <ManageDelegatesBtn users={data} survey={survey} isReadOnly={isReadOnly} />
              </>
            }
          >
            <UsersTable utrvIds={utrvIds} users={users} />
          </ViewTemplate>
        );
      }}
    />
  );
};
